import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isFetchStatusPending } from 'state/fetch-status';
import { getOrganizationNameFromRouteParams } from 'state/selectors-global';

import { fetchOrganizationMemberList } from './redux/organization-level-actions';
import { getOrganizationMembersCount, getOrganizationMembersFetchStatus } from './redux/selectors';

export function useOrganizationMembers() {
  const membersCount = useSelector(getOrganizationMembersCount);
  const organizationName = useSelector(getOrganizationNameFromRouteParams);
  const loading = isFetchStatusPending(useSelector(getOrganizationMembersFetchStatus));

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchOrganizationMemberList({ organizationIdentifier: organizationName }));
  }, [dispatch, organizationName]);

  return {
    membersCount,
    loading,
  };
}
